(function () {
  "use strict";

  var root = document.getElementById("hermes-chat-widget");
  if (!root) return;

  var apiUrl = (root.dataset.apiUrl || "").replace(/\/$/, "");
  if (!apiUrl) return;

  // The backend's /web-chat requires a short-lived, origin-bound widget token
  // (see webhook-server's routes/webChat.ts - signWidgetToken/verifyWidgetToken).
  // Fetched once per page load/session and cached in memory, not localStorage,
  // since it's meant to be short-lived.
  var widgetToken = null;
  var widgetTokenPromise = null;

  function fetchWidgetToken() {
    if (widgetToken) return Promise.resolve(widgetToken);
    if (!widgetTokenPromise) {
      // ngrok-skip-browser-warning: the backend URL is currently a free-tier ngrok
      // tunnel, which shows an HTML interstitial to real browser requests (curl/server
      // requests pass straight through) unless this header is present - harmless no-op
      // against any other host.
      widgetTokenPromise = fetch(apiUrl + "/web-chat/token", {
        headers: { "ngrok-skip-browser-warning": "true" },
      })
        .then(function (res) {
          if (!res.ok) throw new Error("widget_token_fetch_failed");
          return res.json();
        })
        .then(function (data) {
          widgetToken = data.token;
          return widgetToken;
        })
        .catch(function (err) {
          widgetTokenPromise = null;
          throw err;
        });
    }
    return widgetTokenPromise;
  }

  var STORAGE_USER_ID = "hermes_chat_user_id";
  var STORAGE_HISTORY = "hermes_chat_history"; // legacy flat-array format, migrated below
  var STORAGE_CONVERSATIONS = "hermes_chat_conversations";
  var STORAGE_ACTIVE_CONVERSATION = "hermes_chat_active_conversation";
  var STORAGE_TEASER_DISMISSED = "hermes_chat_teaser_dismissed";
  var MAX_STORED_MESSAGES = 40;
  var MAX_STORED_CONVERSATIONS = 20;
  var MAX_CONVERSATION_AGE_MS = 7 * 24 * 60 * 60 * 1000; // messages may hold customer PII (phone/address/order info); don't keep them forever

  function getUserId() {
    var id = localStorage.getItem(STORAGE_USER_ID);
    if (!id) {
      id =
        "web-" +
        Date.now().toString(36) +
        "-" +
        Math.random().toString(36).slice(2, 10);
      localStorage.setItem(STORAGE_USER_ID, id);
    }
    return id;
  }

  function newConversationId() {
    return "chat-" + Date.now().toString(36) + "-" + Math.random().toString(36).slice(2, 8);
  }

  function makeConversation() {
    return { id: newConversationId(), title: "", updatedAt: Date.now(), messages: [] };
  }

  function dropExpired(list) {
    var cutoff = Date.now() - MAX_CONVERSATION_AGE_MS;
    return list.filter(function (c) {
      return c.updatedAt >= cutoff;
    });
  }

  function loadConversations() {
    var raw;
    try {
      raw = JSON.parse(localStorage.getItem(STORAGE_CONVERSATIONS) || "null");
    } catch (e) {
      raw = null;
    }
    if (Array.isArray(raw) && raw.length) return dropExpired(raw);

    // Migrate the old single flat-history format (pre-conversation-list) into
    // one conversation, so returning visitors don't lose the chat they were
    // already in when this feature shipped.
    var legacy;
    try {
      legacy = JSON.parse(localStorage.getItem(STORAGE_HISTORY) || "[]");
    } catch (e) {
      legacy = [];
    }
    if (legacy.length) {
      var migrated = makeConversation();
      migrated.messages = legacy;
      migrated.title = titleFromMessages(legacy);
      return [migrated];
    }
    return [];
  }

  function saveConversations() {
    var trimmed = conversations
      .slice(0, MAX_STORED_CONVERSATIONS)
      .map(function (c) {
        return {
          id: c.id,
          title: c.title,
          updatedAt: c.updatedAt,
          messages: c.messages.slice(-MAX_STORED_MESSAGES),
        };
      });
    try {
      localStorage.setItem(STORAGE_CONVERSATIONS, JSON.stringify(trimmed));
    } catch (e) {
      // storage full/unavailable - the widget still works, just without persistence
    }
  }

  function titleFromMessages(messages) {
    var firstUserMessage = messages.filter(function (m) {
      return m.role === "user" && m.text;
    })[0];
    if (!firstUserMessage) return "New chat";
    return firstUserMessage.text.length > 40
      ? firstUserMessage.text.slice(0, 40) + "…"
      : firstUserMessage.text;
  }

  function getConversation(id) {
    for (var i = 0; i < conversations.length; i++) {
      if (conversations[i].id === id) return conversations[i];
    }
    return null;
  }

  function setActiveConversation(id) {
    activeConversationId = id;
    try {
      localStorage.setItem(STORAGE_ACTIVE_CONVERSATION, id);
    } catch (e) {
      // ignore
    }
  }

  var userId = getUserId();
  var conversations = loadConversations();
  if (!conversations.length) conversations.push(makeConversation());
  conversations.sort(function (a, b) {
    return b.updatedAt - a.updatedAt;
  });

  var activeConversationId = localStorage.getItem(STORAGE_ACTIVE_CONVERSATION);
  if (!getConversation(activeConversationId)) {
    activeConversationId = conversations[0].id;
  }
  saveConversations();

  var toggle = root.querySelector("[data-hermes-chat-avatar-btn]");
  var teaser = root.querySelector("[data-hermes-chat-teaser]");
  var teaserClose = root.querySelector("[data-hermes-chat-teaser-close]");
  var badge = root.querySelector("[data-hermes-chat-badge]");
  var panel = root.querySelector(".hermes-chat__panel");
  var closeBtn = root.querySelector(".hermes-chat__close");
  var messagesEl = root.querySelector("[data-hermes-chat-messages]");
  var form = root.querySelector("[data-hermes-chat-form]");
  var input = root.querySelector("[data-hermes-chat-input]");
  var attachBtn = root.querySelector("[data-hermes-chat-attach]");
  var fileInput = root.querySelector("[data-hermes-chat-file]");
  var cameraBtn = root.querySelector("[data-hermes-chat-camera]");
  var cameraInput = root.querySelector("[data-hermes-chat-camera-file]");
  var micBtn = root.querySelector("[data-hermes-chat-mic]");
  var previewEl = root.querySelector("[data-hermes-chat-preview]");
  var sendBtn = root.querySelector(".hermes-chat__send");
  var historyToggle = root.querySelector("[data-hermes-chat-history-toggle]");
  var historyBack = root.querySelector("[data-hermes-chat-history-back]");
  var historyPanel = root.querySelector("[data-hermes-chat-history]");
  var historyList = root.querySelector("[data-hermes-chat-history-list]");
  var newChatBtn = root.querySelector("[data-hermes-chat-new]");

  var pendingFile = null; // { base64, mimeType, name }
  var isOpen = false;
  var isSending = false;

  root.hidden = false;

  function scrollToBottom() {
    messagesEl.scrollTop = messagesEl.scrollHeight;
  }

  function escapeHtml(str) {
    var div = document.createElement("div");
    div.textContent = str;
    return div.innerHTML;
  }

  function linkifyText(escapedLine) {
    // Operates on already-escaped text, so a literal "&" in a query string
    // arrives here as "&amp;" - still a valid href, browsers decode it back.
    // Excluding '"' here too (not just whitespace/'<') matters: escapeHtml's
    // textContent->innerHTML trick never escapes a literal quote (quotes
    // aren't special in text content, only inside an attribute value), so
    // without this a message containing e.g. https://x.com/"onmouseover="..."
    // would have that entire quote-containing run captured as "url" and
    // concatenated straight into href="...", breaking out of the attribute
    // and injecting a new one. Stopping the match at the quote instead means
    // the malicious part is left behind as inert, already-escaped plain text.
    return escapedLine.replace(/https?:\/\/[^\s<"]+/g, function (url) {
      var trailing = "";
      var trailingMatch = url.match(/[),.!?;:]+$/);
      if (trailingMatch) {
        trailing = trailingMatch[0];
        url = url.slice(0, -trailing.length);
      }
      return '<a href="' + url + '" target="_blank" rel="noopener noreferrer">' + url + "</a>" + trailing;
    });
  }

  function renderInlineMarkdown(escapedLine) {
    // Operates on already-escaped text, so *, |, - are still literal here -
    // only *bold* (single asterisk, matching the bot's own message format)
    // needs converting.
    var bolded = escapedLine.replace(/\*([^*\n]+)\*/g, "<strong>$1</strong>");
    // Confirmed live ("link click needed"): the bot sends a bare product URL
    // as plain text expecting the shopper to tap it, not copy/paste it.
    return linkifyText(bolded);
  }

  function isTableRowLine(line) {
    return /^\s*\|.*\|\s*$/.test(line);
  }

  function isTableSeparatorLine(line) {
    return /^\s*\|?\s*:?-{3,}:?\s*(\|\s*:?-{3,}:?\s*)+\|?\s*$/.test(line);
  }

  function splitTableRow(line) {
    var trimmed = line.trim().replace(/^\|/, "").replace(/\|$/, "");
    return trimmed.split("|").map(function (cell) {
      return cell.trim();
    });
  }

  function renderMarkdownTable(lines) {
    var headerCells = splitTableRow(lines[0]);
    var html = '<table class="hermes-chat__table"><thead><tr>';
    headerCells.forEach(function (cell) {
      html += "<th>" + renderInlineMarkdown(cell) + "</th>";
    });
    html += "</tr></thead><tbody>";
    for (var i = 2; i < lines.length; i++) {
      if (!lines[i].trim()) continue;
      var cells = splitTableRow(lines[i]);
      html += "<tr>";
      cells.forEach(function (cell) {
        html += "<td>" + renderInlineMarkdown(cell) + "</td>";
      });
      html += "</tr>";
    }
    html += "</tbody></table>";
    return html;
  }

  // The bot (Hermes) sends plain-text markdown - *bold* and pipe tables for
  // pricing breakdowns - expecting it to render, not show up as literal
  // asterisks/pipes/dashes. Escapes first (so any raw HTML in the message is
  // inert), then layers real <table>/<strong> markup on top of the escaped
  // text, which is still safe since the regexes only ever match plain
  // characters that survive escaping untouched (*, |, -).
  function renderMessageHtml(rawText) {
    var lines = escapeHtml(rawText).split("\n");
    var blocks = [];
    var i = 0;
    while (i < lines.length) {
      if (isTableRowLine(lines[i]) && i + 1 < lines.length && isTableSeparatorLine(lines[i + 1])) {
        var tableLines = [lines[i], lines[i + 1]];
        var j = i + 2;
        while (j < lines.length && isTableRowLine(lines[j])) {
          tableLines.push(lines[j]);
          j++;
        }
        blocks.push({ type: "table", html: renderMarkdownTable(tableLines) });
        i = j;
      } else {
        blocks.push({ type: "line", html: renderInlineMarkdown(lines[i]) });
        i++;
      }
    }
    var result = "";
    for (var k = 0; k < blocks.length; k++) {
      if (k > 0 && blocks[k - 1].type !== "table") result += "<br>";
      result += blocks[k].html;
    }
    return result;
  }

  function renderBubble(kind, text, imageDataUrl) {
    var bubble = document.createElement("div");
    bubble.className = "hermes-chat__bubble hermes-chat__bubble--" + kind;

    if (imageDataUrl) {
      var img = document.createElement("img");
      img.className = "hermes-chat__bubble-image";
      img.src = imageDataUrl;
      img.alt = "Attached photo";
      bubble.appendChild(img);
    }

    if (text) {
      var textEl = document.createElement("div");
      textEl.className = "hermes-chat__bubble-text";
      textEl.innerHTML = renderMessageHtml(text);
      bubble.appendChild(textEl);
    }

    messagesEl.appendChild(bubble);
    scrollToBottom();
    return bubble;
  }

  // The cart link the assistant sends with a card ("/cart/add?items[0][id]=..&items[0][quantity]=..")
  // already holds exactly what the customer asked for (e.g. 10 x Maroon, or a combo set).
  function cartItemsFrom(cartUrl) {
    try {
      var url = new URL(cartUrl, window.location.origin);
      var items = [];
      for (var i = 0; i < 50; i++) {
        var id = url.searchParams.get("items[" + i + "][id]");
        if (!id) break;
        items.push({ id: Number(id), quantity: Math.max(1, Number(url.searchParams.get("items[" + i + "][quantity]")) || 1) });
      }
      // Single-variant products often get the simpler ?id=X&quantity=Y cart-add
      // URL (no items[N][] array) instead of the multi-item bundle format above -
      // without this fallback, every single-colour product silently got no
      // "Add to cart" button while only multi-item bundles (full/combo sets) did.
      if (!items.length) {
        var singleId = url.searchParams.get("id");
        if (singleId) {
          items.push({ id: Number(singleId), quantity: Math.max(1, Number(url.searchParams.get("quantity")) || 1) });
        }
      }
      return items;
    } catch (e) {
      return [];
    }
  }

  // Adds the card's exact items to the shopper's cart right here in the chat (Shopify Ajax cart API).
  function addToCart(button, items, cartUrl) {
    var pieces = items.reduce(function (n, it) { return n + it.quantity; }, 0);
    button.disabled = true;
    button.textContent = "Adding...";
    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items: items }),
    })
      .then(function (res) {
        return res.json().then(function (body) { return { ok: res.ok, body: body }; });
      })
      .then(function (r) {
        if (!r.ok) throw new Error((r.body && (r.body.description || r.body.message)) || "Couldn't add to cart");
        button.textContent = "\u2705 Added " + pieces + " to cart";
        button.disabled = false;
        // The theme's quick cart (mini-cart drawer), not the cart page: theme.js opens and refreshes it
        // on "product:added" - the same event the theme's own add-to-cart buttons fire. The chat stays
        // open (on desktop the drawer shows above it). On phones the chat fills the screen, so
        // "View cart" steps the chat aside to show the drawer; the conversation is kept.
        document.body.dispatchEvent(new CustomEvent("product:added", { bubbles: true, detail: { quantity: pieces } }));
        if (!button.parentNode.querySelector(".hermes-chat__view-cart")) {
          var view = document.createElement("button");
          view.type = "button";
          view.className = "hermes-chat__view-cart";
          view.textContent = "View cart \u2192";
          view.style.cssText = "display:block;width:100%;margin-top:4px;padding:4px 0;border:0;background:none;cursor:pointer;font:inherit;font-size:12px;font-weight:700;color:var(--heading-color,#4A0E17);";
          view.addEventListener("click", function () {
            closePanel();
            document.body.dispatchEvent(new CustomEvent("product:added", { bubbles: true, detail: { quantity: 0 } }));
          });
          button.parentNode.appendChild(view);
        }
      })
      .catch(function (err) {
        button.disabled = false;
        button.textContent = "\uD83D\uDED2 Add to cart";
        var note = document.createElement("span");
        note.style.cssText = "display:block;margin-top:4px;font-size:11px;color:#B42318;";
        note.textContent = String(err.message || err) + " - ";
        var open = document.createElement("a");
        open.href = cartUrl;
        open.textContent = "open cart";
        open.style.color = "inherit";
        note.appendChild(open);
        button.parentNode.appendChild(note);
      });
  }

  // Fallback for products the backend didn't supply a cartUrl for (so far, only
  // combo/full-set bundles reliably carry one) - resolves the variant to add via
  // the theme's own public product JSON at click time, so every product with at
  // least a slug/productUrl can still get a working "Add to cart" button.
  function addSingleProductToCart(button, handle) {
    button.disabled = true;
    button.textContent = "Loading...";
    fetch("/products/" + encodeURIComponent(handle) + ".js", { headers: { Accept: "application/json" } })
      .then(function (res) {
        if (!res.ok) throw new Error("not_found");
        return res.json();
      })
      .then(function (product) {
        // "Bulk (N+ qty)" variants are untracked price tiers that always
        // report available - never add one directly, or a sold-out saree
        // could still be bought at the bulk price (snippets/product-in-stock).
        var variants = (product.variants || []).filter(function (v) { return String(v.title || "").indexOf("Bulk (") === -1; });
        var variant = variants.filter(function (v) { return v.available; })[0] || variants[0];
        if (!variant) throw new Error("no_variant");
        if (!variant.available) {
          button.disabled = true;
          button.textContent = "Out of stock";
          return;
        }
        addToCart(button, [{ id: variant.id, quantity: 1 }], null);
      })
      .catch(function () {
        button.disabled = false;
        button.textContent = "🛒 Add to cart";
        var note = document.createElement("span");
        note.style.cssText = "display:block;margin-top:4px;font-size:11px;color:#B42318;";
        note.textContent = "Couldn't load this product.";
        button.parentNode.appendChild(note);
      });
  }

  function renderProducts(products) {
    if (!products || !products.length) return;
    var wrap = document.createElement("div");
    wrap.className = "hermes-chat__products";

    products.forEach(function (p) {
      var item = document.createElement("div");
      item.className = "hermes-chat__product-item";

      var card = document.createElement("a");
      card.className = "hermes-chat__product-card";
      card.href = p.productUrl || (p.slug ? "/products/" + p.slug : "#");
      card.target = "_blank";
      card.rel = "noopener noreferrer";

      var img = document.createElement("img");
      img.src = p.imageUrl || "";
      img.alt = p.name || "";
      img.loading = "lazy";
      // Images load async and grow the card's height after the initial
      // scrollToBottom() call below - without this, the bottom of the last
      // product card (price/Add to cart) stays hidden below the fold.
      img.addEventListener("load", scrollToBottom);
      card.appendChild(img);

      var info = document.createElement("div");
      info.className = "hermes-chat__product-info";

      var name = document.createElement("span");
      name.className = "hermes-chat__product-name";
      name.textContent = p.name || "";
      info.appendChild(name);

      var metaParts = [];
      if (p.sareeCode) metaParts.push(p.sareeCode);
      if (typeof p.priceRupees === "number") metaParts.push("₹" + p.priceRupees.toLocaleString("en-IN"));
      if (metaParts.length) {
        var meta = document.createElement("span");
        meta.className = "hermes-chat__product-meta";
        meta.textContent = metaParts.join(" · ");
        info.appendChild(meta);
      }

      card.appendChild(info);
      item.appendChild(card);

      var handle = p.slug || null;
      if (!handle && p.productUrl) {
        var handleMatch = String(p.productUrl).match(/\/products\/([^/?#]+)/);
        if (handleMatch) handle = handleMatch[1];
      }

      var items = p.cartUrl ? cartItemsFrom(p.cartUrl) : [];
      if (items.length) {
        var pieces = items.reduce(function (n, it) { return n + it.quantity; }, 0);
        var add = document.createElement("button");
        add.type = "button";
        add.className = "hermes-chat__add-to-cart";
        add.textContent = "\uD83D\uDED2 Add " + (pieces > 1 ? pieces + " pcs " : "") + "to cart";
        add.style.cssText = "display:block;width:100%;margin-top:6px;padding:8px 0;border:0;border-radius:8px;cursor:pointer;font:inherit;font-size:12.5px;font-weight:700;background:var(--heading-color,#4A0E17);color:#fff;";
        add.addEventListener("click", function () { addToCart(add, items, p.cartUrl); });
        item.appendChild(add);
      } else if (handle) {
        var addSingle = document.createElement("button");
        addSingle.type = "button";
        addSingle.className = "hermes-chat__add-to-cart";
        addSingle.textContent = "\uD83D\uDED2 Add to cart";
        addSingle.style.cssText = "display:block;width:100%;margin-top:6px;padding:8px 0;border:0;border-radius:8px;cursor:pointer;font:inherit;font-size:12.5px;font-weight:700;background:var(--heading-color,#4A0E17);color:#fff;";
        addSingle.addEventListener("click", function () { addSingleProductToCart(addSingle, handle); });
        item.appendChild(addSingle);
      }

      wrap.appendChild(item);
    });

    messagesEl.appendChild(wrap);
    scrollToBottom();
  }

  function showTyping() {
    var bubble = document.createElement("div");
    bubble.className = "hermes-chat__bubble hermes-chat__bubble--typing";
    bubble.setAttribute("data-typing", "1");
    bubble.innerHTML = "<span></span><span></span><span></span>";
    messagesEl.appendChild(bubble);
    scrollToBottom();
    return bubble;
  }

  function renderActiveConversation() {
    messagesEl.innerHTML = "";
    var conversation = getConversation(activeConversationId);
    if (!conversation) return;
    conversation.messages.forEach(function (entry) {
      renderBubble(entry.role === "user" ? "user" : "bot", entry.text);
      if (entry.products) renderProducts(entry.products);
      if (entry.location) renderLocationCard(entry.location);
    });
    if (!conversation.messages.length) showGreeting();
  }

  function showGreeting() {
    var greeting = root.dataset.greeting;
    if (!greeting) return;
    renderBubble("bot", greeting);
  }

  function formatConversationDate(timestamp) {
    try {
      return new Date(timestamp).toLocaleString(undefined, {
        month: "short",
        day: "numeric",
        hour: "numeric",
        minute: "2-digit",
      });
    } catch (e) {
      return "";
    }
  }

  function renderHistoryList() {
    historyList.innerHTML = "";
    if (!conversations.length) {
      var empty = document.createElement("p");
      empty.className = "hermes-chat__history-empty";
      empty.textContent = "No past chats yet.";
      historyList.appendChild(empty);
      return;
    }
    conversations
      .slice()
      .sort(function (a, b) {
        return b.updatedAt - a.updatedAt;
      })
      .forEach(function (conversation) {
        var item = document.createElement("button");
        item.type = "button";
        item.className = "hermes-chat__history-item";
        if (conversation.id === activeConversationId) {
          item.className += " hermes-chat__history-item--active";
        }

        var title = document.createElement("p");
        title.className = "hermes-chat__history-item-title";
        title.textContent = conversation.title || "New chat";
        item.appendChild(title);

        var meta = document.createElement("p");
        meta.className = "hermes-chat__history-item-meta";
        meta.textContent = formatConversationDate(conversation.updatedAt);
        item.appendChild(meta);

        item.addEventListener("click", function () {
          setActiveConversation(conversation.id);
          renderActiveConversation();
          closeHistoryPanel();
        });

        historyList.appendChild(item);
      });
  }

  function openHistoryPanel() {
    renderHistoryList();
    historyPanel.hidden = false;
  }

  function closeHistoryPanel() {
    historyPanel.hidden = true;
  }

  function startNewChat() {
    var current = getConversation(activeConversationId);
    // Don't pile up empty "New chat" entries if the customer never sent
    // anything in the one they're already on.
    if (current && !current.messages.length) {
      renderActiveConversation();
      closeHistoryPanel();
      return;
    }
    var conversation = makeConversation();
    conversations.unshift(conversation);
    setActiveConversation(conversation.id);
    saveConversations();
    renderActiveConversation();
    closeHistoryPanel();
  }

  if (historyToggle) historyToggle.addEventListener("click", openHistoryPanel);
  if (historyBack) historyBack.addEventListener("click", closeHistoryPanel);
  if (newChatBtn) newChatBtn.addEventListener("click", startNewChat);

  function setBadge(show) {
    badge.hidden = !show;
  }

  function teaserDismissedThisSession() {
    try {
      return sessionStorage.getItem(STORAGE_TEASER_DISMISSED) === "1";
    } catch (e) {
      return false;
    }
  }

  function dismissTeaser() {
    if (teaser) teaser.hidden = true;
    try {
      sessionStorage.setItem(STORAGE_TEASER_DISMISSED, "1");
    } catch (e) {
      // storage unavailable - the teaser just stays visible until reload
    }
  }

  var isMobilePanel = window.matchMedia("(max-width: 749px)");

  function syncPanelToVisualViewport() {
    if (!window.visualViewport || !isMobilePanel.matches) {
      panel.style.width = "";
      panel.style.height = "";
      panel.style.top = "";
      panel.style.left = "";
      return;
    }
    // iOS Safari's position:fixed doesn't reliably track the real visible
    // area once the on-screen keyboard opens (a long-standing WebKit bug) -
    // the panel can end up clipped/offset from the actual screen. Actively
    // sizing/positioning it from visualViewport (which does track the real
    // visible area) keeps it correctly full-screen regardless of keyboard.
    var vv = window.visualViewport;
    panel.style.width = vv.width + "px";
    panel.style.height = vv.height + "px";
    panel.style.top = vv.offsetTop + "px";
    panel.style.left = vv.offsetLeft + "px";
  }

  if (window.visualViewport) {
    window.visualViewport.addEventListener("resize", syncPanelToVisualViewport);
    window.visualViewport.addEventListener("scroll", syncPanelToVisualViewport);
  }

  function openPanel() {
    isOpen = true;
    panel.hidden = false;
    toggle.setAttribute("aria-expanded", "true");
    setBadge(false);
    if (teaser) teaser.hidden = true;
    syncPanelToVisualViewport();
    input.focus();
    scrollToBottom();
  }

  function closePanel() {
    isOpen = false;
    panel.hidden = true;
    toggle.setAttribute("aria-expanded", "false");
    if (teaser && !teaserDismissedThisSession()) teaser.hidden = false;
    closeHistoryPanel();
    stopListening();
  }

  toggle.addEventListener("click", function () {
    if (isOpen) closePanel();
    else openPanel();
  });
  closeBtn.addEventListener("click", closePanel);

  if (teaserClose) {
    teaserClose.addEventListener("click", function (event) {
      event.stopPropagation();
      dismissTeaser();
    });
  }
  if (teaser) {
    teaser.addEventListener("click", openPanel);
    if (teaserDismissedThisSession()) teaser.hidden = true;
  }

  attachBtn.addEventListener("click", function () {
    fileInput.click();
  });
  if (cameraBtn && cameraInput) {
    cameraBtn.addEventListener("click", function () {
      cameraInput.click();
    });
  }

  var IMAGE_MAX_DIMENSION = 1280;
  var IMAGE_JPEG_QUALITY = 0.72;
  var IMAGE_SAFE_RAW_BYTES = 700 * 1024; // backend rejects requests once the base64 payload passes ~1MB

  function readFileAsDataUrl(file) {
    return new Promise(function (resolve, reject) {
      var reader = new FileReader();
      reader.onload = function () {
        resolve(String(reader.result || ""));
      };
      reader.onerror = function () {
        reject(reader.error || new Error("file_read_failed"));
      };
      reader.readAsDataURL(file);
    });
  }

  function compressImageDataUrl(dataUrl) {
    return new Promise(function (resolve, reject) {
      var img = new Image();
      img.onload = function () {
        var scale = Math.min(1, IMAGE_MAX_DIMENSION / Math.max(img.width, img.height));
        var canvas = document.createElement("canvas");
        canvas.width = Math.round(img.width * scale);
        canvas.height = Math.round(img.height * scale);
        var ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
        resolve(canvas.toDataURL("image/jpeg", IMAGE_JPEG_QUALITY));
      };
      img.onerror = function () {
        reject(new Error("image_decode_failed"));
      };
      img.src = dataUrl;
    });
  }

  function handleSelectedFile(file) {
    if (!file) return;
    if (file.size > 8 * 1024 * 1024) {
      previewEl.hidden = false;
      previewEl.textContent = "That photo is too large (max 8MB) - try a smaller one.";
      resetFileInputs();
      return;
    }

    readFileAsDataUrl(file)
      .then(function (dataUrl) {
        if (file.size <= IMAGE_SAFE_RAW_BYTES) return dataUrl;
        return compressImageDataUrl(dataUrl).catch(function () {
          return dataUrl; // fall back to the original if it isn't a decodable raster image
        });
      })
      .then(function (finalDataUrl) {
        var base64 = finalDataUrl.split(",")[1] || "";
        var mimeType = finalDataUrl.slice(5, finalDataUrl.indexOf(";")) || file.type || "image/jpeg";
        pendingFile = { base64: base64, mimeType: mimeType, name: file.name };
        previewEl.hidden = false;
        previewEl.textContent = "📷 " + file.name + " attached - add a note or tap send";
      })
      .catch(function () {
        previewEl.hidden = false;
        previewEl.textContent = "Couldn't read that photo - try a different one.";
        resetFileInputs();
      });
  }

  function resetFileInputs() {
    fileInput.value = "";
    if (cameraInput) cameraInput.value = "";
  }

  fileInput.addEventListener("change", function () {
    var file = fileInput.files && fileInput.files[0];
    handleSelectedFile(file);
  });
  if (cameraInput) {
    cameraInput.addEventListener("change", function () {
      var file = cameraInput.files && cameraInput.files[0];
      handleSelectedFile(file);
    });
  }

  // Voice typing - the browser's built-in speech recognition fills the
  // message box (nothing is recorded or uploaded by this widget). The mic
  // button stays hidden on browsers without it (e.g. Firefox).
  var SpeechRecognitionCtor = window.SpeechRecognition || window.webkitSpeechRecognition;
  var recognition = null;
  var isListening = false;

  function setListening(listening) {
    isListening = listening;
    micBtn.classList.toggle("is-listening", listening);
    micBtn.setAttribute("aria-pressed", listening ? "true" : "false");
    micBtn.setAttribute("aria-label", listening ? "Stop listening" : "Speak your message");
    micBtn.title = listening ? "Stop listening" : "Speak your message";
    input.placeholder = listening ? "Listening..." : "Type your message...";
  }

  function stopListening() {
    if (recognition && isListening) recognition.stop();
  }

  if (micBtn && SpeechRecognitionCtor) {
    micBtn.hidden = false;
    micBtn.addEventListener("click", function () {
      if (isListening) {
        stopListening();
        return;
      }
      var baseText = input.value ? input.value.replace(/\s+$/, "") + " " : "";
      recognition = new SpeechRecognitionCtor();
      recognition.lang = "en-IN";
      recognition.interimResults = true;
      recognition.continuous = false;
      recognition.onresult = function (event) {
        var transcript = "";
        for (var i = 0; i < event.results.length; i++) {
          transcript += event.results[i][0].transcript;
        }
        input.value = (baseText + transcript).slice(0, input.maxLength > 0 ? input.maxLength : 2000);
      };
      recognition.onerror = function (event) {
        if (event.error === "not-allowed" || event.error === "service-not-allowed") {
          previewEl.hidden = false;
          previewEl.textContent = "Microphone access is blocked - allow it in your browser settings to speak your message.";
        } else if (event.error === "no-speech") {
          previewEl.hidden = false;
          previewEl.textContent = "Didn't catch that - tap the mic and try again.";
        }
      };
      recognition.onend = function () {
        setListening(false);
        recognition = null;
        input.focus();
      };
      try {
        recognition.start();
        setListening(true);
        if (!pendingFile) {
          previewEl.hidden = true;
          previewEl.textContent = "";
        }
      } catch (err) {
        setListening(false);
        recognition = null;
      }
    });
  }

  var dragCounter = 0;

  panel.addEventListener("dragenter", function (event) {
    event.preventDefault();
    dragCounter++;
    panel.classList.add("hermes-chat__panel--drag-over");
  });

  panel.addEventListener("dragover", function (event) {
    event.preventDefault();
    if (event.dataTransfer) event.dataTransfer.dropEffect = "copy";
  });

  panel.addEventListener("dragleave", function (event) {
    event.preventDefault();
    dragCounter = Math.max(0, dragCounter - 1);
    if (dragCounter === 0) panel.classList.remove("hermes-chat__panel--drag-over");
  });

  panel.addEventListener("drop", function (event) {
    event.preventDefault();
    dragCounter = 0;
    panel.classList.remove("hermes-chat__panel--drag-over");
    var file = event.dataTransfer && event.dataTransfer.files && event.dataTransfer.files[0];
    if (!file) return;
    if (file.type && file.type.indexOf("image/") !== 0) {
      previewEl.hidden = false;
      previewEl.textContent = "Only photos can be attached here.";
      return;
    }
    handleSelectedFile(file);
  });

  function clearPendingFile() {
    pendingFile = null;
    resetFileInputs();
    previewEl.hidden = true;
    previewEl.textContent = "";
  }

  function setSending(sending) {
    isSending = sending;
    sendBtn.disabled = sending;
    attachBtn.disabled = sending;
    if (cameraBtn) cameraBtn.disabled = sending;
    if (micBtn) micBtn.disabled = sending;
    if (sending && micBtn) stopListening();
  }

  // The shopper's website cart (variant id, quantity, title) - sent with every message.
  function readStoreCart() {
    return fetch("/cart.js", { headers: { Accept: "application/json" } })
      .then(function (res) { return res.ok ? res.json() : null; })
      .then(function (cart) {
        if (!cart || !cart.items) return null;
        // Marks the cart as chatted-in, so an order placed from it is credited to the assistant
        // on the MetaBasket dashboard (it shows on the order as a note attribute).
        if (!cart.attributes || !cart.attributes["MetaBasket chat"]) {
          fetch("/cart/update.js", {
            method: "POST",
            headers: { "Content-Type": "application/json", Accept: "application/json" },
            body: JSON.stringify({ attributes: { "MetaBasket chat": userId } }),
          }).catch(function () {});
        }
        return cart.items.slice(0, 50).map(function (it) { return { variantId: String(it.variant_id), quantity: it.quantity, title: String(it.title || "").slice(0, 200) }; });
      })
      .catch(function () { return null; });
  }

  // "add 2 maroon" in chat: the assistant sends the exact items, added here to the real website
  // cart; the theme's mini cart then opens (same "product:added" event as its own buttons).
  function addItemsToStoreCart(items) {
    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items: items.map(function (i) { return { id: Number(i.variantId), quantity: i.qty }; }) }),
    })
      .then(function (res) { return res.json().then(function (b) { return { ok: res.ok, body: b }; }); })
      .then(function (r) {
        if (!r.ok) throw new Error((r.body && (r.body.description || r.body.message)) || "Couldn't add to cart");
        var pieces = items.reduce(function (n, i) { return n + i.qty; }, 0);
        document.body.dispatchEvent(new CustomEvent("product:added", { bubbles: true, detail: { quantity: pieces } }));
      })
      .catch(function (err) {
        renderBubble("error", "Sorry, I couldn't add that to your cart: " + String(err.message || err));
      });
  }

  // Checkout: the delivery-details form the assistant asks for (pre-filled with earlier details).
  var inputCss = "display:block;width:100%;box-sizing:border-box;margin-top:3px;padding:8px 10px;border:1px solid var(--border-color,#E3D9BE);border-radius:8px;font:inherit;font-size:13px;background:#fff;color:inherit;";
  function renderDetailsForm(form) {
    if (!form || !form.fields || !form.fields.length) return;
    var box = document.createElement("form");
    box.className = "hermes-chat__details-form";
    box.noValidate = true;
    box.style.cssText = "flex-shrink:0;align-self:stretch;margin:2px 0 8px;padding:12px;border:1px solid var(--border-color,#E3D9BE);border-radius:12px;background:var(--secondary-background,#fff);";
    var title = document.createElement("div");
    title.textContent = "\uD83D\uDCE6 " + (form.title || "Delivery details");
    title.style.cssText = "font-weight:700;font-size:13.5px;margin-bottom:8px;color:var(--heading-color,#4A0E17);";
    box.appendChild(title);
    var inputs = {};
    form.fields.forEach(function (f) {
      var label = document.createElement("label");
      label.style.cssText = "display:block;margin-bottom:8px;font-size:12px;font-weight:600;";
      label.textContent = f.label + (f.required ? " *" : "");
      var input = document.createElement(f.type === "textarea" ? "textarea" : "input");
      if (f.type !== "textarea") input.type = f.type === "tel" ? "tel" : f.type === "email" ? "email" : "text";
      else input.rows = 2;
      input.name = f.name;
      input.value = f.value || "";
      if (f.required) input.required = true;
      if (f.name === "pincode") { input.inputMode = "numeric"; input.maxLength = 6; }
      if (f.name === "phone") { input.inputMode = "tel"; input.maxLength = 13; }
      input.style.cssText = inputCss + (f.error ? "border-color:#B42318;" : "");
      label.appendChild(input);
      if (f.error) {
        var err = document.createElement("span");
        err.textContent = f.error;
        err.style.cssText = "display:block;margin-top:2px;font-size:11px;font-weight:500;color:#B42318;";
        label.appendChild(err);
      }
      box.appendChild(label);
      inputs[f.name] = input;
    });
    var submit = document.createElement("button");
    submit.type = "submit";
    submit.textContent = form.submitLabel || "Continue";
    submit.style.cssText = "display:block;width:100%;margin-top:4px;padding:10px 0;border:0;border-radius:8px;cursor:pointer;font:inherit;font-size:13.5px;font-weight:700;background:var(--heading-color,#4A0E17);color:#fff;";
    box.appendChild(submit);
    box.addEventListener("submit", function (e) {
      e.preventDefault();
      var details = {};
      var missing = false;
      form.fields.forEach(function (f) {
        var v = String(inputs[f.name].value || "").trim();
        details[f.name] = v;
        inputs[f.name].style.borderColor = f.required && !v ? "#B42318" : "";
        if (f.required && !v) missing = true;
      });
      if (missing) return;
      submit.disabled = true;
      submit.textContent = "Sending...";
      Array.prototype.forEach.call(box.elements, function (el) { el.disabled = true; });
      if (isSending) return;
      var summary = "My delivery details: " + details.name + ", " + details.phone + ", " + details.address + ", " + details.city + " - " + details.pincode;
      renderBubble("user", summary);
      sendMessage(summary, null, { checkoutDetails: details });
    });
    messagesEl.appendChild(box);
    scrollToBottom();
  }

  // Checkout: "Confirm & get payment link" under the order summary.
  function renderConfirmButton(confirm) {
    if (!confirm || !confirm.message) return;
    var btn = document.createElement("button");
    btn.type = "button";
    btn.textContent = confirm.label || "Confirm";
    btn.style.cssText = "flex-shrink:0;align-self:flex-start;margin:2px 0 8px;padding:10px 18px;border:0;border-radius:10px;cursor:pointer;font:inherit;font-size:14px;font-weight:700;background:#12B76A;color:#fff;box-shadow:0 2px 8px rgba(18,183,106,.35);";
    btn.addEventListener("click", function () {
      if (isSending) return;
      btn.disabled = true;
      btn.textContent = "Confirming...";
      renderBubble("user", "Confirm");
      sendMessage(confirm.message);
    });
    messagesEl.appendChild(btn);
    scrollToBottom();
  }

  // The payment link from the assistant, as one clear button under its reply.
  function renderPayButton(payment) {
    if (!payment || !/^https:\/\//.test(String(payment.url))) return;
    var wrap = document.createElement("div");
    wrap.className = "hermes-chat__pay";
    wrap.style.cssText = "flex-shrink:0;align-self:flex-start;margin:2px 0 6px;";
    var pay = document.createElement("a");
    pay.href = payment.url;
    pay.target = "_blank";
    pay.rel = "noopener noreferrer";
    pay.textContent = "\uD83D\uDCB3 " + (payment.label || "Pay now");
    pay.style.cssText = "display:inline-block;padding:10px 18px;border-radius:10px;background:#12B76A;color:#fff;font-weight:700;font-size:14px;text-decoration:none;box-shadow:0 2px 8px rgba(18,183,106,.35);";
    wrap.appendChild(pay);
    messagesEl.appendChild(wrap);
    scrollToBottom();
  }

  // "Where is your shop?": a small live map with the address, timing and a directions button.
  function renderLocationCard(location) {
    if (!location || !/^https:\/\//.test(String(location.mapsUrl))) return;
    var card = document.createElement("div");
    card.className = "hermes-chat__location";
    card.style.cssText = "flex-shrink:0;align-self:flex-start;width:min(280px,85%);margin:2px 0 6px;border:1px solid var(--border-color,#E3D9BE);border-radius:14px;overflow:hidden;background:#fff;box-shadow:0 2px 10px rgba(0,0,0,.06);";
    if (/^https:\/\/maps\.google\.com\//.test(String(location.embedUrl))) {
      var map = document.createElement("iframe");
      map.src = location.embedUrl;
      map.title = "Map: " + (location.name || "our shop");
      map.loading = "lazy";
      map.referrerPolicy = "no-referrer-when-downgrade";
      map.style.cssText = "display:block;width:100%;height:150px;border:0;";
      card.appendChild(map);
    }
    var body = document.createElement("div");
    body.style.cssText = "padding:10px 12px 12px;font-size:13px;line-height:1.45;color:#222;";
    var title = document.createElement("div");
    title.style.cssText = "font-weight:700;font-size:14px;margin-bottom:2px;";
    title.textContent = "\uD83D\uDCCD " + (location.name || "Our shop");
    body.appendChild(title);
    [location.address, location.hours ? "\uD83D\uDD59 " + location.hours : "", location.phone ? "\uD83D\uDCDE " + location.phone : ""].forEach(function (line) {
      if (!line) return;
      var p = document.createElement("div");
      p.style.cssText = "color:#555;";
      p.textContent = line;
      body.appendChild(p);
    });
    var go = document.createElement("a");
    go.href = location.mapsUrl;
    go.target = "_blank";
    go.rel = "noopener noreferrer";
    go.textContent = "Get directions \u2197";
    go.style.cssText = "display:block;margin-top:10px;padding:9px 12px;border-radius:10px;background:#1A73E8;color:#fff;font-weight:700;text-align:center;text-decoration:none;";
    body.appendChild(go);
    card.appendChild(body);
    messagesEl.appendChild(card);
    scrollToBottom();
  }

  async function sendMessage(text, file, extra) {
    var typingBubble = showTyping();
    setSending(true);

    try {
      var body = { userId: userId, conversationId: activeConversationId, message: text || "" };
      // The website cart goes with every message (an empty one too): it is the only cart - the
      // assistant prices "pay" from it and never keeps a separate cart of its own.
      var storeCart = await readStoreCart();
      if (storeCart) body.storeCart = storeCart;
      if (extra && extra.checkoutDetails) body.checkoutDetails = extra.checkoutDetails;
      if (file) {
        body.mediaType = "image";
        body.mediaBase64 = file.base64;
        body.mediaMimeType = file.mimeType;
      }

      try {
        await fetchWidgetToken();
      } catch (e) {
        typingBubble.remove();
        renderBubble("error", "Sorry, I couldn't reach our assistant just now. Please try again in a moment.");
        return;
      }

      var response = await fetch(apiUrl + "/web-chat", {
        method: "POST",
        headers: {
          "content-type": "application/json",
          "x-widget-token": widgetToken,
          "ngrok-skip-browser-warning": "true",
        },
        body: JSON.stringify(body),
      });

      if (response.status === 401) {
        // Token expired/invalid - mint a fresh one and retry exactly once.
        widgetToken = null;
        widgetTokenPromise = null;
        try {
          await fetchWidgetToken();
          response = await fetch(apiUrl + "/web-chat", {
            method: "POST",
            headers: {
          "content-type": "application/json",
          "x-widget-token": widgetToken,
          "ngrok-skip-browser-warning": "true",
        },
            body: JSON.stringify(body),
          });
        } catch (e) {
          // fall through - the still-failing response below is handled by !response.ok
        }
      }

      typingBubble.remove();

      if (!response.ok) {
        renderBubble("error", "Sorry, I couldn't reach our assistant just now. Please try again in a moment.");
        return;
      }

      var result = await response.json();
      if (result.aiPaused) {
        // A person from the store is handling this chat (the AI is paused in the MetaBaskets Inbox) -
        // their reply arrives through pollTeamReplies below.
        var pausedConversation = getConversation(activeConversationId);
        if (pausedConversation) {
          pausedConversation.messages.push({ role: "user", text: file ? text || "[Photo]" : text });
          pausedConversation.updatedAt = Date.now();
          if (!pausedConversation.title) pausedConversation.title = titleFromMessages(pausedConversation.messages);
        }
        if (!teamNoteShown) {
          teamNoteShown = true;
          var note = "Thanks! Someone from our team will reply here shortly.";
          renderBubble("bot", note);
          if (pausedConversation) pausedConversation.messages.push({ role: "bot", text: note });
        }
        saveConversations();
        return;
      }
      var answer = result.answer || "Sorry, I didn't quite get that - could you rephrase?";
      renderBubble("bot", answer);
      renderProducts(result.relatedProducts);
      renderPayButton(result.payment);
      renderLocationCard(result.location);
      renderDetailsForm(result.form);
      renderConfirmButton(result.confirm);
      if (result.cartAdd && result.cartAdd.length) addItemsToStoreCart(result.cartAdd);

      var conversation = getConversation(activeConversationId);
      if (conversation) {
        conversation.messages.push({ role: "user", text: file ? text || "[Photo]" : text });
        conversation.messages.push({ role: "bot", text: answer, products: result.relatedProducts, location: result.location });
        conversation.updatedAt = Date.now();
        if (!conversation.title) conversation.title = titleFromMessages(conversation.messages);
        saveConversations();
      }

      if (!isOpen) setBadge(true);
    } catch (error) {
      typingBubble.remove();
      renderBubble("error", "Sorry, I couldn't reach our assistant just now. Please check your connection and try again.");
    } finally {
      setSending(false);
      try { localStorage.setItem(STORAGE_LAST_SENT, String(Date.now())); } catch (e) {}
      scheduleTeamPoll();
    }
  }

  // Replies a person sends from the MetaBaskets Inbox. This widget has no open connection, so once
  // the shopper has chatted it checks every few seconds (chat open) or every 15s (closed), and stops
  // a day after their last message.
  var STORAGE_UPDATES_AFTER = "hermes_chat_updates_after";
  var STORAGE_LAST_SENT = "hermes_chat_last_sent";
  var teamPollTimer = null;
  var teamNoteShown = false;
  function scheduleTeamPoll() {
    clearTimeout(teamPollTimer);
    var last = 0;
    try { last = Number(localStorage.getItem(STORAGE_LAST_SENT)) || 0; } catch (e) {}
    if (Date.now() - last > 24 * 60 * 60 * 1000) return;
    teamPollTimer = setTimeout(pollTeamReplies, isOpen ? 4000 : 15000);
  }
  function pollTeamReplies() {
    var after = null;
    try { after = localStorage.getItem(STORAGE_UPDATES_AFTER); } catch (e) {}
    fetchWidgetToken()
      .then(function () {
        return fetch(apiUrl + "/web-chat/updates?userId=" + encodeURIComponent(userId) + (after ? "&after=" + encodeURIComponent(after) : ""), {
          headers: { "x-widget-token": widgetToken, "ngrok-skip-browser-warning": "true" },
        });
      })
      .then(function (res) {
        if (res.status === 401) { widgetToken = null; widgetTokenPromise = null; return null; }
        return res.ok ? res.json() : null;
      })
      .then(function (data) {
        if (!data) return;
        var messages = data.messages || [];
        if (messages.length) {
          var conversation = getConversation(activeConversationId);
          messages.forEach(function (m) {
            var text = String(m.text || "");
            if (!text) return;
            renderBubble("bot", text);
            if (conversation) conversation.messages.push({ role: "bot", text: text });
          });
          if (conversation) { conversation.updatedAt = Date.now(); saveConversations(); }
          if (!isOpen) setBadge(true);
        }
        if (data.now) { try { localStorage.setItem(STORAGE_UPDATES_AFTER, String(data.now)); } catch (e) {} }
      })
      .catch(function () {})
      .then(scheduleTeamPoll);
  }
  scheduleTeamPoll();

  form.addEventListener("submit", function (event) {
    event.preventDefault();
    if (isSending) return;

    var text = input.value.trim();
    var file = pendingFile;
    if (!text && !file) return;

    var imageDataUrl = file ? "data:" + file.mimeType + ";base64," + file.base64 : null;
    renderBubble("user", text, imageDataUrl);
    input.value = "";
    clearPendingFile();
    sendMessage(text, file);
  });

  renderActiveConversation();
})();
